import * as R from 'ramda'
import { sort } from './common'
import { tasks, managers, properties } from './entities'
import { commentsByObjectID } from './index'
import { attachmentsByObjectID } from './attachments'
import { tasksByProjectID, openTasksByProjectID } from './tasks'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { filteredCollection } from './filters'
import { createSearchAction, getSearchSelectors } from 'redux-search'

export let projectStatus = tasks => project => {
	if(!tasks[project._id]) return {...project, projectStatus: project.status? project.status.toLowerCase(): 'open'}
	let status = "pending"
	if(project.status == "Closed"){
		status = "closed"
	}else if(R.any(task => !task.done, tasks[project._id])){
		status = "open"
	}
	return {...project, projectStatus: status}
}

export let projectsEx = createSelector(
	[filteredCollection('project'), properties, commentsByObjectID, attachmentsByObjectID, tasksByProjectID, openTasksByProjectID, managers]
  ,	(projects, properties, commentsByObjectID, attachmentsByObjectID, tasksByProjectID, openTasksByProjectID, managers) => {
		let extend = project => ({
			...project
		  , attachments: attachmentsByObjectID[project._id] || []
		  , comments: commentsByObjectID[project._id] || []
		  , tasks: openTasksByProjectID[project._id] || []
		  , managerName: managers[project.managerID]? managers[project.managerID].name: ""
		  , propertyAlias: properties[project.propertyID]? properties[project.propertyID].alias : "All"
		  , status: projectStatus(openTasksByProjectID)(project)
		  , projectStatus: projectStatus(openTasksByProjectID)(project) && projectStatus(openTasksByProjectID)(project).status
		  , id: project._id
			, dateStarted: new Date(project.createdAt) || ""
			, dateClosed: project.status === "Closed" && new Date(project.updatedAt) || ""
		})
		return R.map(extend)(projects)
	}
)

let {
	text
  , result //  ids
  , unfilteredResult
} = getSearchSelectors({
  resourceName: 'project',
  resourceSelector: (resourceName, state) => {let res = projectsEx(state); return res}
})
export let projectsTable = createSelector(
	[projectsEx, text, result, unfilteredResult, sort('project', {secondary: 'title'})],
	(projectsEx, text, result, unfilteredResult, sort) => {
		// console.log('projectsTable', text, unfilteredResult, result, projectsEx)
		if(text) {
			// console.log("proj projectsEx", projectsEx)
			// console.log("proj text", text)
			// console.log("proj result", result)
			projectsEx = R.map(id => projectsEx[id], result)
			// console.log("proj projectsEx MAPPED", projectsEx)
		}
		// else console.log('unfiltered projects', sort.fn(projectsEx))

		return sort.fn(projectsEx)
	}
)



// WEBPACK FOOTER //
// ./src/selectors/projects.js